/* ═══ ER CART · Elevaine ═══════════════════════════════════════════════════
   Tiroir panier unique de la boutique (section `er-cart-drawer`).

   · Un seul aller-retour par action : /cart/add.js et /cart/change.js
     renvoient directement le HTML du tiroir (Section Rendering API).
   · Bouton verrouillé pendant l'ajout, tiroir ouvert immédiatement.
   · Bonus automatique : ajouté dès le palier, retiré en dessous.
   · Compatibilité : les anciens déclencheurs (classe body `open-cart-drawer`,
     sectionRedering, cartDrawerOpen/Hide, addToCartProduct, ajaxProduct:added,
     ocu:cart:open) ouvrent ce tiroir ; toute modification du panier faite par
     un autre script est détectée et resynchronisée.

   Vanilla JS, aucune dépendance. Créé le 2026-09-11.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.ERCart) return;

  var SECTION = 'er-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var LANG = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var TXT = {
    fr: { added: 'Ajouté à votre panier', error: 'Une erreur est survenue. Merci de réessayer.', u: ['j', 'h', 'm', 's'] },
    it: { added: 'Aggiunto al carrello', error: 'Si è verificato un errore. Riprova.', u: ['g', 'h', 'm', 's'] },
    en: { added: 'Added to your cart', error: 'Something went wrong. Please try again.', u: ['d', 'h', 'm', 's'] }
  }[LANG] || null;
  if (!TXT) TXT = { added: 'Ajouté à votre panier', error: 'Une erreur est survenue. Merci de réessayer.', u: ['j', 'h', 'm', 's'] };

  /* Déclencheurs d'ajout pris en charge */
  var MAIN_TRIGGERS = '.main-product__addTo, .sticky__right a';
  var ID_TRIGGERS = '[data-er-add], .main-product__upsell-action a, .main-product__upsell-item a, .upsell_main a, .eo-atc, .eop-atc-trigger';

  var root, panel, content, errorEl, liveEl;
  var busy = false;
  var lastFocus = null;
  var lastHtml = '';
  var deadlineTimer = null;
  var errorTimer = null;
  var foreignTimer = null;

  /* ── Mesure Clarity : 3 étapes du tiroir, une fois par page ────────────
     Clarity ne reconnaît plus l'ajout au panier depuis la refonte du tiroir
     (1 session taguée contre 21 côté Shopify, constaté le 14/09). On nomme
     donc nous-mêmes les étapes. Si Clarity est absent ou bloqué, rien ne part
     et rien ne casse. */
  var mesures = {};
  var mesuresEnAttente = [];
  var mesureMinuteur = null;

  function mesure(nom) {
    if (mesures[nom]) return;
    mesures[nom] = true;
    envoyerMesure(nom);
  }

  function envoyerMesure(nom) {
    try {
      if (typeof window.clarity === 'function') { window.clarity('event', nom); return; }
    } catch (e) { return; }
    if (mesuresEnAttente.indexOf(nom) === -1) mesuresEnAttente.push(nom);
    if (mesureMinuteur) return;
    var essais = 0;
    mesureMinuteur = setInterval(function () {
      if (typeof window.clarity === 'function') {
        while (mesuresEnAttente.length) {
          try { window.clarity('event', mesuresEnAttente.shift()); } catch (e) { break; }
        }
        clearInterval(mesureMinuteur); mesureMinuteur = null;
      } else if (++essais > 40) { clearInterval(mesureMinuteur); mesureMinuteur = null; }
    }, 250);
  }

  var ctaObservateur = null;
  function observerCta() {
    if (mesures.er_cta_paiement_vu || !('IntersectionObserver' in window)) return;
    var cta = content && qs('[data-er-checkout]', content);
    if (!cta) return;
    if (ctaObservateur) ctaObservateur.disconnect();
    ctaObservateur = new IntersectionObserver(function (entrees) {
      if (entrees[0].isIntersecting && isOpen()) {
        mesure('er_cta_paiement_vu');
        ctaObservateur.disconnect(); ctaObservateur = null;
      }
    }, { threshold: 0.5 });
    ctaObservateur.observe(cta);
  }

  function noop() {}
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }
  function isOpen() { return !!root && root.classList.contains('is-open'); }

  /* ── Réseau ─────────────────────────────────────────────────────────── */

  function request(path, body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || '');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  /* Rendu à la demande via /search : neutre sur toutes les pages. Pas d'en-tête
     Accept JSON : sur /products et /pages, il renvoie la ressource au lieu de la section. */
  function refresh() {
    return fetch(ROOT + 'search?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) { if (data && data[SECTION]) render(data[SECTION]); });
  }

  function apply(data) {
    if (data && data.sections && data.sections[SECTION]) {
      render(data.sections[SECTION]);
      return Promise.resolve();
    }
    return refresh();
  }

  /* ── Rendu ──────────────────────────────────────────────────────────── */

  function render(html) {
    if (!content || html === lastHtml) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('er-cart-content');
    if (!fresh) return;
    lastHtml = html;

    var oldBody = qs('.er-body', content);
    var scrollTop = oldBody ? oldBody.scrollTop : 0;

    content.parentNode.replaceChild(document.importNode(fresh, true), content);
    content = qs('#er-cart-content', root);

    var newBody = qs('.er-body', content);
    if (newBody && scrollTop) newBody.scrollTop = scrollTop;
    sync();
  }

  function sync() {
    var d = content.dataset;
    root.classList.toggle('is-empty-state', (+d.count || 0) === 0);
    updateCounters(+d.itemCount || 0);
    observerCta();
    if (isOpen()) startDeadline();
  }

  function updateCounters(count) {
    var nodes = document.querySelectorAll('.cart-link__bubble-num, [data-er-count]');
    Array.prototype.forEach.call(nodes, function (n) { n.textContent = count; });
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    Array.prototype.forEach.call(bubbles, function (b) { b.classList.toggle('cart-link__bubble--visible', count > 0); });
  }

  /* ── Bonus automatique ──────────────────────────────────────────────── */

  function ensureGift() {
    var d = content && content.dataset;
    if (!d || !d.giftVariant || !(+d.giftGoal > 0)) return Promise.resolve();

    var paid = +d.count || 0;
    var qualifying = +d.qualifying || 0;
    var goal = +d.giftGoal;
    var hasGift = d.hasGift === 'true';
    var line = +d.giftLine || 0;
    var qty = +d.giftQty || 0;

    if (paid > 0 && qualifying >= goal && !hasGift) {
      return request('cart/add.js', { items: [{ id: +d.giftVariant, quantity: 1 }] }).then(apply).catch(noop);
    }
    if (hasGift && line && (paid === 0 || qualifying < goal)) {
      return request('cart/change.js', { line: line, quantity: 0 }).then(apply).catch(noop);
    }
    if (hasGift && line && qty > 1) {
      return request('cart/change.js', { line: line, quantity: 1 }).then(apply).catch(noop);
    }
    return Promise.resolve();
  }

  /* ── Actions ────────────────────────────────────────────────────────── */

  function setBusy(on, trigger) {
    busy = on;
    root.classList.toggle('is-busy', on);
    if (trigger && trigger.classList && !root.contains(trigger)) {
      trigger.classList.toggle('er-is-loading', on);
      if (on) trigger.setAttribute('aria-busy', 'true');
      else trigger.removeAttribute('aria-busy');
    }
  }

  function run(trigger, work) {
    if (busy) return Promise.resolve();
    setBusy(true, trigger);
    hideError();
    return Promise.resolve()
      .then(work)
      .then(ensureGift)
      .catch(function (err) {
        showError(err && err.message);
        return refresh().catch(noop);
      })
      .then(function () { setBusy(false, trigger); });
  }

  function add(items, trigger) {
    open();
    return run(trigger, function () {
      return request('cart/add.js', { items: items }).then(apply).then(function () {
        announce(TXT.added);
        mesure('er_ajout_panier');
        document.dispatchEvent(new CustomEvent('er-cart:added', { detail: { items: items } }));
      });
    });
  }

  /* Pages qui l'activent (data-er-permalinks sur le tiroir, ex. /pages/levres) :
     les liens « panier direct » /cart/ID:Q,ID:Q?discount=CODE passent par le tiroir
     au lieu d'aller droit au paiement. Le code est appliqué au panier et l'offre
     est notée dans l'attribut er_offre (lu par le tiroir pour le cadeau et la date). */
  function permalinkOffer(el) {
    var href = el.getAttribute('href');
    if (!href || href.indexOf('/cart/') === -1) return null;
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return null; }
    if (u.origin !== window.location.origin) return null;
    var m = u.pathname.match(/\/cart\/(\d+:\d+(?:,\d+:\d+)*)\/?$/);
    if (!m) return null;
    var items = m[1].split(',').map(function (pair) {
      var p = pair.split(':');
      return { id: +p[0], quantity: Math.max(1, +p[1] || 1) };
    });
    return { items: items, code: u.searchParams.get('discount') || '' };
  }

  function addOffer(offer, trigger) {
    open();
    return run(trigger, function () {
      return request('cart/add.js', { items: offer.items }).then(function () {
        var body = { attributes: { er_offre: root.getAttribute('data-er-permalinks') } };
        if (offer.code) body.discount = offer.code;
        return request('cart/update.js', body);
      }).then(apply).then(function () {
        announce(TXT.added);
        mesure('er_ajout_panier');
        document.dispatchEvent(new CustomEvent('er-cart:added', { detail: { items: offer.items } }));
      });
    });
  }

  /* Tiroir lèvres v3 : changer de durée (1/2/3 mois) en un seul appel */
  function swap(from, to, trigger) {
    if (busy || !from || !to || from === to) return;
    var updates = {};
    updates[from] = 0;
    updates[to] = 1;
    mesure('er_choix_duree');
    run(trigger, function () {
      return request('cart/update.js', { updates: updates }).then(apply);
    });
  }

  /* Tiroir lèvres v3 : fenêtre email (calque plein tiroir).
     Déclencheurs : 1re fermeture du tiroir (croix, fond, Échap) et, sur ordinateur,
     souris qui sort par le haut de la fenêtre. Jamais si l'email est déjà donné,
     si « Non merci » a été choisi dans la session, ou après la date limite. */
  function store(kind, name, set) {
    try {
      var st = kind === 'local' ? localStorage : sessionStorage;
      if (set) { st.setItem(name, '1'); return true; }
      return st.getItem(name) === '1';
    } catch (e) { return !!set; }
  }
  function flag(name, set) { return store('session', name, set); }
  function captureBox() { return content && qs('[data-er-capture]', content); }
  function hideCapture() {
    var box = captureBox();
    if (box) box.hidden = true;
    if (root) root.classList.remove('is-capturing');
  }
  function maybeCapture() {
    var box = captureBox();
    if (!box || !box.hidden) return false;
    if (store('local', 'er_capture_done') || flag('er_capture_vue')) return false;
    var until = box.getAttribute('data-er-capture-until');
    if (until && new Date(until) <= new Date()) return false;
    flag('er_capture_vue', true);
    box.hidden = false;
    root.classList.add('is-capturing');
    mesure('er_capture_vue');
    var input = qs('input[type=email]', box);
    if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { /* ancien */ } }, 320);
    return true;
  }
  function captureDone(box) {
    if (!box) return;
    store('local', 'er_capture_done', true);
    mesure('er_capture_email');
    box.hidden = false;
    box.classList.add('is-done');
    root.classList.add('is-capturing');
    var f = qs('[data-er-capture-form]', box); if (f) f.hidden = true;
    var ok = qs('[data-er-capture-ok]', box); if (ok) ok.hidden = false;
  }
  function onCaptureSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-er-capture-form]')) return;
    var input = qs('input[type=email]', form);
    var err = qs('[data-er-capture-err]', form);
    if (input && !input.checkValidity()) { e.preventDefault(); if (err) err.hidden = false; input.focus(); return; }
    if (err) err.hidden = true;
    /* Envoi classique (le formulaire client Shopify refuse les envois en arrière-plan et interdit
       l'affichage en cadre). Retour sur la même page avec ?er_capture=1 : le tiroir se rouvre sur
       « C'est noté ». Si Shopify demande sa case anti-robot, le retour depuis /challenge est reconnu. */
    var back = form.querySelector('input[name=return_to]');
    if (back) {
      var q = window.location.search.replace(/([?&])er_capture=1&?/, '$1').replace(/[?&]$/, '');
      back.value = window.location.pathname + (q ? q + '&' : '?') + 'er_capture=1';
    }
    flag('er_capture_pending', true);
    var btn = qs('button[type=submit]', form);
    if (btn) setTimeout(function () { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }, 0);
  }

  function change(line, quantity, trigger) {
    if (busy || !line) return;
    var lineEl = trigger && trigger.closest ? trigger.closest('.er-line') : null;
    if (lineEl) lineEl.classList.add('is-updating');
    run(trigger, function () {
      return request('cart/change.js', { line: line, quantity: Math.max(0, quantity) }).then(apply);
    }).then(function () {
      if (lineEl && lineEl.isConnected) lineEl.classList.remove('is-updating');
    });
  }

  function open() {
    if (!root || isOpen()) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('er-cart-lock');
    observerCta();
    startDeadline();
    setTimeout(function () {
      try { panel.focus({ preventScroll: true }); } catch (e) { /* navigateur ancien */ }
    }, 60);
  }

  function close() {
    if (!root) return;
    hideCapture();
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('er-cart-lock');
    document.body.classList.remove('open-cart-drawer', 'klaviyo-prevent-body-scrolling');
    var chat = document.getElementById('shopify-chat');
    if (chat && chat.style.display === 'none') chat.style.removeProperty('display');
    stopDeadline();
    hideError();
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* navigateur ancien */ }
    }
  }

  /* ── Compte à rebours « jusqu'à dimanche » (même règle que l'ancien tiroir) ── */

  function nextSunday() {
    var now = new Date();
    var end = new Date(now);
    end.setDate(now.getDate() + ((7 - now.getDay()) % 7));
    end.setHours(23, 0, 0, 0);
    if (end <= now) end.setDate(end.getDate() + 7);
    return end;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function paintDeadline() {
    var el = content && qs('[data-er-deadline]', content);
    if (!el) return;
    var at = el.getAttribute('data-er-deadline-at');
    var target = at ? new Date(at) : nextSunday();
    if (at && target <= new Date()) {
      var band = el.closest('.er-band');
      if (band) band.hidden = true;
      return;
    }
    var s = Math.max(0, Math.floor((target - new Date()) / 1000));
    var cdWrap = at ? el.closest('[data-er-cd]') : null;
    if (cdWrap) cdWrap.hidden = s > 172800;
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    el.textContent = (d ? d + TXT.u[0] + ' ' : '') + pad(h) + TXT.u[1] + ' ' + pad(m) + TXT.u[2] + ' ' + pad(sec) + TXT.u[3];
  }
  function startDeadline() {
    stopDeadline();
    paintDeadline();
    deadlineTimer = setInterval(paintDeadline, 1000);
  }
  function stopDeadline() {
    if (deadlineTimer) clearInterval(deadlineTimer);
    deadlineTimer = null;
  }

  /* ── Messages ───────────────────────────────────────────────────────── */

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message || TXT.error;
    errorEl.hidden = false;
    clearTimeout(errorTimer);
    errorTimer = setTimeout(hideError, 6000);
  }
  function hideError() { if (errorEl) errorEl.hidden = true; }
  function announce(message) {
    if (!liveEl) return;
    liveEl.textContent = '';
    setTimeout(function () { liveEl.textContent = message; }, 60);
  }

  /* ── Lecture de l'offre sélectionnée ───────────────────────────────── */

  function mainItem() {
    var form = document.querySelector('form.single__product-add-pro');
    if (!form) return null;
    try { if (typeof window.matchVariant === 'function') window.matchVariant(); } catch (e) { /* jQuery absent */ }
    var data = new FormData(form);
    var ids = data.getAll('id');
    var id = ids.length ? ids[ids.length - 1] : null;
    if (!id) return null;

    var item = { id: +id, quantity: Math.max(1, parseInt(data.get('quantity'), 10) || 1) };
    var plan = data.get('selling_plan');
    if (plan) item.selling_plan = +plan;
    var props = {};
    data.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof value === 'string' && value !== '') props[m[1]] = value;
    });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  function idItem(el) {
    var id = el.getAttribute('data-er-add') || el.getAttribute('data-product-id') || el.getAttribute('data-variant');
    return id && +id ? { id: +id, quantity: 1 } : null;
  }

  /* ── Événements ─────────────────────────────────────────────────────── */

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var el;
    if (root.getAttribute('data-er-permalinks')) {
      el = t.closest('a[href]');
      var offer = el && !root.contains(el) ? permalinkOffer(el) : null;
      if (offer) {
        stop(e);
        if (!busy) addOffer(offer, el);
        return;
      }
    }

    el = t.closest(MAIN_TRIGGERS);
    if (el) {
      var item = mainItem() || idItem(el);
      if (!item) return;
      stop(e);
      if (!busy) add([item], el);
      return;
    }

    el = t.closest(ID_TRIGGERS);
    if (el) {
      if (el.getAttribute('data-discount')) return; /* flux « code promo » des pages offre : laissé intact */
      var byId = idItem(el);
      if (!byId) return;
      stop(e);
      if (!busy) add([byId], el);
      return;
    }

    if (!root.contains(t)) return;

    if ((el = t.closest('[data-er-close-force]'))) { stop(e); hideCapture(); close(); return; }
    if ((el = t.closest('[data-er-capture-back]'))) { stop(e); hideCapture(); return; }
    if ((el = t.closest('[data-er-close]'))) { stop(e); if (!maybeCapture()) close(); return; }
    if ((el = t.closest('[data-er-swap]'))) {
      stop(e);
      var pair = el.getAttribute('data-er-swap').split(':');
      swap(+pair[0], +pair[1], el);
      return;
    }
    if ((el = t.closest('[data-er-remove]'))) { stop(e); change(+el.getAttribute('data-er-remove'), 0, el); return; }
    if ((el = t.closest('[data-er-qty]'))) { stop(e); change(+el.getAttribute('data-er-qty'), +el.getAttribute('data-qty'), el); return; }
    if ((el = t.closest('[data-er-checkout]'))) {
      if (busy) { stop(e); return; }
      mesure('er_cta_paiement_clic');
      el.classList.add('is-leaving');
    }
  }

  function onChange(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-er-protect]')) return;
    if (busy) { t.checked = !t.checked; return; }
    var line = +t.getAttribute('data-line') || 0;
    if (t.checked && !line) {
      run(t, function () {
        return request('cart/add.js', { items: [{ id: +t.getAttribute('data-er-protect'), quantity: 1 }] }).then(apply);
      });
    } else if (!t.checked && line) {
      change(line, 0, t);
    }
  }

  function onKey(e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') {
      var cb = captureBox();
      if (cb && !cb.hidden) { hideCapture(); close(); return; }
      if (!maybeCapture()) close();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusables = Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (x) { return x.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ── Compatibilité avec les scripts existants ───────────────────────── */

  function openAndSync() {
    open();
    refresh().then(function () { return run(null, noop); }).catch(noop);
  }

  function bridge() {
    window.sectionRedering = function (callback) {
      return refresh()
        .then(function () { return run(null, noop); })
        .catch(noop)
        .then(function () { if (typeof callback === 'function') callback(); });
    };
    window.handleFreeGiftLogic = function () { return run(null, noop); };
    window.addToCartProduct = function (e, el) {
      if (e && e.preventDefault) e.preventDefault();
      var item = el ? idItem(el) : null;
      if (item) add([item], el);
    };
    window.cartDrawerOpen = function (e) {
      if (e && e.preventDefault) e.preventDefault();
      openAndSync();
    };
    window.cartDrawerHide = function (e) {
      if (e && e.preventDefault) e.preventDefault();
      close();
    };

    new MutationObserver(function () {
      if (document.body.classList.contains('open-cart-drawer') && !isOpen()) openAndSync();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('ajaxProduct:added', openAndSync);
    window.addEventListener('ocu:cart:open', openAndSync);

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      close();
      Array.prototype.forEach.call(document.querySelectorAll('.er-cta.is-leaving'), function (b) { b.classList.remove('is-leaving'); });
      refresh().catch(noop);
    });

    /* Panier modifié par un autre script (app, page offre…) → resynchronisation */
    if ('PerformanceObserver' in window) {
      try {
        new PerformanceObserver(function (list) {
          var touched = list.getEntries().some(function (entry) {
            return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entry.name);
          });
          if (!touched || busy) return;
          clearTimeout(foreignTimer);
          foreignTimer = setTimeout(function () {
            if (busy) return;
            refresh().then(function () { return run(null, noop); }).catch(noop);
          }, 350);
        }).observe({ type: 'resource', buffered: false });
      } catch (e) { /* navigateur ancien : resynchronisation à l'ouverture */ }
    }
  }

  /* ── Démarrage ──────────────────────────────────────────────────────── */

  function init() {
    root = document.querySelector('[data-er-cart]');
    if (!root) return;

    /* Rattaché directement au <body> : aucun parent transformé ne peut casser le position:fixed */
    var wrapper = root.closest('.shopify-section') || root;
    if (wrapper.parentNode !== document.body) document.body.appendChild(wrapper);

    panel = qs('.er-cart__panel', root);
    content = qs('#er-cart-content', root);
    errorEl = qs('[data-er-error]', root);
    liveEl = qs('[data-er-live]', root);

    window.addEventListener('click', onClick, true);
    document.addEventListener('change', onChange);
    document.addEventListener('submit', onCaptureSubmit, true);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && isOpen() && window.matchMedia('(pointer: fine)').matches) maybeCapture();
    });
    document.addEventListener('keydown', onKey);
    bridge();

    /* Retour d'un envoi classique du formulaire email : on rouvre le tiroir sur la confirmation */
    var viaChallenge = false;
    try { viaChallenge = sessionStorage.getItem('er_capture_pending') === '1' && /\/challenge/.test(document.referrer); } catch (e) { /* stockage bloqué */ }
    if (/[?&]er_capture=1/.test(window.location.search) || viaChallenge) {
      try { sessionStorage.removeItem('er_capture_pending'); } catch (e) { /* stockage bloqué */ }
      try {
        var cleanQ = window.location.search.replace(/([?&])er_capture=1&?/, '$1').replace(/[?&]$/, '');
        history.replaceState(null, '', window.location.pathname + cleanQ + window.location.hash);
      } catch (e) { /* ancien navigateur */ }
      setTimeout(function () {
        open();
        refresh().then(function () { captureDone(content && qs('[data-er-capture]', content)); }).catch(noop);
      }, 300);
    }

    window.ERCart = {
      open: openAndSync,
      close: close,
      refresh: refresh,
      add: function (items) { return add(items, null); }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
